import React, { Component } from "react"
import PropTypes from "prop-types"
import { getAccountSettings } from "../../scripts/accountSettings"
import { isomorphicVars } from "../../scripts/isomorphicVars"
import { injectIntl } from "react-intl"
import settingsMessages from "../../messages/settings"

class Image extends Component {
  constructor(props) {
    super(props)

    const postfixValue = typeof props.src === "string" ? props.src : props.src.value
    const postfix = postfixValue.indexOf("?") === -1 ? "?" : "&"
    const { version } = isomorphicVars()

    const src = props.skipVersion
      ? props.src
      : `${props.src}${postfix}v=${version}`

    this.state = {
      src,
      errored: false
    }
  }

  onError = error => {
    console.warn("load Inage error", this.props.src)
    const accountSettings = getAccountSettings(
      this.props.intl.formatMessage(settingsMessages.authenticAccountId)
    )
    if (!this.state.errored) {
      this.setState(
        {
          src: accountSettings.defaultImage,
          errored: true
        },
        () => {
          if (this.props.backgroundImage) {
            this._imgEl.parentElement.style.backgroundImage = `url(${
              accountSettings.defaultImage
            })`
          }
        }
      )
    }
  }

  render() {
    const { src } = this.state
    const {
      src: _1,
      backgroundImage: _2,
      skipVersion: _3,
      intl: _4,
      ...props
    } = this.props

    return (
      <img
        ref={el => {
          this._imgEl = el
        }}
        src={src}
        onError={this.onError}
        {...props}
      />
    )
  }
}

Image.propTypes = {
  src: PropTypes.string,
  backgroundImage: PropTypes.bool,
  skipVersion: PropTypes.bool
}

export default injectIntl(Image)



// WEBPACK FOOTER //
// ./webapp/components/elements/Image.js